<script>
import ImageViewer from 'element-ui/packages/image/src/image-viewer.vue';
let prevOverflow = '';
export default {
  name: "driverDetail",
  props: {
    driverInfo: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ImageViewer,
  },
  computed: {
    imageIndex() {
      let previewIndex = 0;
      const initialIndex = this.initialIndex;
      if (initialIndex >= 0) {
        previewIndex = initialIndex;
        return previewIndex;
      }
      const srcIndex = this.previewSrcList.indexOf(this.src);
      if (srcIndex >= 0) {
        previewIndex = srcIndex;
        return previewIndex;
      }
      return previewIndex;
    }
  },
  data() {
    return {
      driverDialogVisible: false,
      initialIndex: 0,
      previewSrcList: [],
      showViewer: false
    }
  },
  methods: {
    editHandle() {
      this.$emit("edit", this.driverInfo)
    },
    commandHandler(command) {
      this.$emit("command", command);
    },
    previewHandle(type) {
      let src = ''
      if (type === 'license') src = this.driverInfo.license_document_url;
      if (type === 'residency') src = this.driverInfo.residency_document_url;
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.showViewer = true;
      this.previewSrcList = [src];
    },
    closeViewer() {
      document.body.style.overflow = prevOverflow;
      this.showViewer = false;
      this.previewSrcList = [];
    },

  }
}
</script>

<template>
  <el-dialog custom-class="driver_detail" width="497px" :title="driverInfo.name"  :visible.sync="driverDialogVisible">
    <el-form :model="driverInfo" label-width="126px">
      <el-form-item
          label="UID:"
      >
        <div class="mt-4">{{driverInfo.uid}}</div>
      </el-form-item>
      <el-form-item
          label="Cellphone No.:"
      >
        <div class="mt-4">{{driverInfo.phone}}</div>
      </el-form-item>
      <el-form-item
          label="Created at:"
      >
        <div class="mt-4">{{driverInfo.created_at}}</div>
      </el-form-item>
      <el-form-item
          label="Last device OS:"
      >
        <div class="mt-4">{{driverInfo.last_device}}</div>
      </el-form-item>
      <div class="h-[1px] bg-[#E0E0E0] w-full mt-4"></div>
      <el-form-item
          label="Email:"
      >
        <div class="mt-4">{{driverInfo.email}}</div>
      </el-form-item>
      <el-form-item
          label="Driver's licence number:"
      >
        <div class="mt-4 flex justify-between">
          <div>{{driverInfo.license_number}}</div>
          <span class="underline cursor-pointer" @click="previewHandle('license')">View</span>
        </div>
      </el-form-item>
      <el-form-item
          label="Residency status:"
      >
        <div class="mt-4 flex justify-between">
          <div>{{driverInfo.residency_status}}</div>
          <span class="underline cursor-pointer" @click="previewHandle('residency')">View</span>
        </div>
      </el-form-item>
      <el-form-item
          label="Metropolitan area code:"
      >
        <div class="mt-4">{{driverInfo.ma_code}} {{driverInfo.metropolitan_area}}</div>
      </el-form-item>
      <el-form-item
          label="Zone code:"
      >
        <div class="mt-4">{{driverInfo.zone_codes_text}}</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-dropdown
          @command="commandHandler"
          class="mr-4"
      >
        <el-button type="danger" class="py-0 bg-[#e95646]">
          {{driverInfo.status ? 'Deactive' : 'Active'}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="driver_dropdown">
          <el-dropdown-item :command="driverInfo.status ? 'deactive' : 'active'" class="w-[123px]">{{driverInfo.status ? 'Deactive' : 'Active'}}</el-dropdown-item>
          <el-dropdown-item command="delete" class="w-[123px]">Delete</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="success" @click="editHandle">Edit</el-button>
    </div>
    <image-viewer :z-index="3000" :initial-index="imageIndex" v-if="showViewer" :on-close="closeViewer" :url-list="previewSrcList"/>
  </el-dialog>
</template>

<style lang="less">
.driver_detail{
  .el-form-item__label{
    margin-bottom: 0 !important;
  }
  .el-dialog__footer{
    padding-top: 24px;
    border-top: 1px solid #E0E0E0;
  }
}
.driver_dropdown{
  &.el-dropdown-menu {
    border: 1px solid #E95646
  }
  .el-dropdown-menu__item{
    line-height: 32px;
    color: #E95646;
    &:hover{
      background-color: #FFFFFF !important;
      color: #E95646 !important;
    }
  }
}
</style>
